import React, { useEffect } from 'react';
import CoolTabs from 'react-cool-tabs';
import FranchiseStore from './FranchiseStore/FranchiseStore';
import FlagShipStore from './FlagShipStore/FlagShipStore';
import './StoreLocationPage.scss';

export default (function StoreLocationPage(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="store-location-page">
        <div className="section-header">
          <h1 className="section-header-title">Ladenstandorte</h1>
        </div>
        <CoolTabs
          tabKey="1"
          style={{ width: '100%', minHeight: '1000px', background: 'white' }}
          tabsHeaderStyle={{ margin: '0px 100px' }}
          activeTabStyle={{ background: '#fff', color: '#000' }}
          unActiveTabStyle={{ background: '#fff', color: '#000' }}
          activeLeftTabBorderBottomStyle={{ background: '#000', height: 2 }}
          activeRightTabBorderBottomStyle={{ background: '#000', height: 2 }}
          tabsBorderBottomStyle={{ background: 'black', height: 1 }}
          leftContentStyle={{ background: '#fff' }}
          rightContentStyle={{ background: '#fff' }}
          leftTabTitle="Flagship-Store"
          rightTabTitle="Franchise-Store"
          leftTabTitleStyle={{}}
          leftContent={<FlagShipStore />}
          rightContent={<FranchiseStore />}
        />
      </div>
    </div>
  );
});
